<template>
  <vx-card class="md:w-1/2 mt-base upload-card">
    <div>
      <div v-if="isUploaded">
        <feather-icon  class="upload-icon" icon="FileIcon"></feather-icon>
        <p class="mt-4 text-center truncate">{{ fileName }}</p>
      </div>
      <div v-else>
        <feather-icon class="upload-icon" icon="UploadIcon"></feather-icon>
        <p class="mt-4 text-center">请选择文件</p>
      </div>
    </div>
    <input class="upload-input" type="file" @change="upload($event)" accept=".txt, .sb3, .zip">
    <vs-progress v-if="!showProgress" :percent="currentProgress" color="primary">primary</vs-progress>
    <p v-else class="text-center text-sm" style="color: #aaa">（点击重新上传）</p>
  </vx-card>
</template>

<script>

import { uploadFile } from '@/api/upload'
import { getToken } from '@/utils/tools'

export default {
  name: 'upload-file',
  props: {
    default: String,
    alias: String,
  },
  data () {
    return {
      fileName: '',
      progress: 0,
    }
  },
  created() {
    this.fileName = this.default
    if (this.fileName) {
      this.progress = 100
    }
    
  },
  computed: {
    isUploaded() {
      return this.fileName != '';
    },
    currentProgress() {
      return this.progress
    },
    showProgress() {
      return this.progress === 100
    }
  },
  methods: {
    upload(e) {
      let that = this
      
      const files = e.target.files
      if (files.length == 0) {
        return
      }
      console.log(files[0])
      if (that.alias) {
        that.fileName = `${that.alias}.${files[0].name.substring(files[0].name.lastIndexOf('.') + 1)}`
      } else {
        that.fileName = files[0].name
      }
      
      that.progress = 0

      const formData = new FormData()
      formData.append('access_token', getToken())
      formData.append('file', files[0])

      // 配置
      let config = {
        data: formData,
        onUploadProgress: event => {
          let complete = (event.loaded / event.total * 100 | 0)
          that.progress = complete
        }
      }

      uploadFile(config).then(res => {
        if (res.data.err_code == 0) {
          that.$emit('url', res.data.path)
          that.$vs.notify({
            color: 'success',
            title: '提示',
            text: '上传成功！',
            iconPack: 'feather',
            icon:'icon-alert-circle'
          })
        } else {
          that.fileName = ''
          that.progress = 0
        }
      })
    }
  }
}
</script>

<style>
  .upload-card:hover {
    box-shadow: 1px 1px 24px #ccc;
  }
  .upload-icon {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .upload-input {
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
    position: absolute;
    top:0;
    left: 0;
    cursor: pointer;
  }
</style>